import useSiteRevampContent from '../../content/useSiteRevampContent'

// A static grid rather than a marquee: the hero above already carries the
// rotating orbit, and a grid shows all fourteen names at once instead of a few
// at a time. Most globally recognisable marks lead, so a visitor who does not
// know the Brazilian market still lands on something familiar.
//
// Every mark is flattened to white. Brightening only worked for logos that were
// already light: Segware ships near black (avg 8/255) and disappeared entirely.
const logos = [
  ['logo_porter.svg', 'Porter'],
  ['logo_vale.png', 'Vale'],
  ['logo_ambevtech.png', 'Ambev Tech'],
  ['logo_softplan.png', 'Softplan'],
  ['logo_segware.png', 'Segware'],
  ['logo_solides.png', 'Solides'],
  ['logo_inside.png', 'Inside'],
  ['logo_contele.png', 'Contele'],
  ['logo_ndd.png', 'NDD'],
  ['logo_hbsis.png', 'HBSIS'],
  ['logo_solarview.png', 'SolarView'],
  ['logo_blueticket.png', 'BlueTicket'],
  ['logo_prs.png', 'PRS'],
  ['logo_stormtech.png', 'StormTech'],
]

const CustomerLogosSection = () => {
  const content = useSiteRevampContent()

  return (
    <section className="bg-transparent px-6 py-20 md:px-16">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-pyramid-1/60">
            {content.home.credibility.headline}
          </p>
          <p className="mt-4 text-lg leading-8 text-slate-400">
            {content.home.credibility.body}
          </p>
        </div>

        {/* Centred flex rather than a rigid grid: fourteen logos divide into a
            ragged last row, and this keeps that row centred. The container width
            caps the run at five per row. */}
        <ul className="mx-auto mt-16 flex max-w-[1000px] flex-wrap justify-center gap-x-14 gap-y-16">
          {logos.map(([file, name]) => (
            <li key={file} className="flex w-[112px] items-center justify-center sm:w-[132px] lg:w-[150px]">
              <img
                src={`/images/logo_clients/${file}`}
                alt={name}
                loading="lazy"
                className="max-h-11 w-full object-contain opacity-50 brightness-0 invert transition duration-300 ease-out hover:scale-[1.28] hover:opacity-100"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default CustomerLogosSection
